"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const inline_style_prefixer_1 = require("inline-style-prefixer");
const decamelize_1 = __importDefault(require("./utils/decamelize"));
const prefixRegex = /^(Webkit|ms|Moz|O)/;
/**
 * Adds vendor prefixes to properties and values.
 */
function prefixer(property, value) {
    const rules = inline_style_prefixer_1.prefix({ [property]: value });
    const rulesArray = [];
    const propertyNames = Object.keys(rules);
    // Convert rules object to an array
    for (let i = 0; i < propertyNames.length; i++) {
        const propertyName = propertyNames[i];
        // Add a dash in front of the prefixes
        const prefixedProp = propertyName.match(prefixRegex)
            ? `-${propertyName}`
            : propertyName;
        const prop = decamelize_1.default(prefixedProp);
        const values = rules[propertyName];
        // Handle prefixed values
        if (Array.isArray(values)) {
            for (let j = 0; j < values.length; j++) {
                rulesArray.push({ property: prop, value: values[j] });
            }
        }
        else {
            rulesArray.push({ property: prop, value: values });
        }
    }
    return rulesArray;
}
exports.default = prefixer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJlZml4ZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvcHJlZml4ZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSxpRUFBNEM7QUFDNUMsb0VBQTJDO0FBRTNDLE1BQU0sV0FBVyxHQUFHLG9CQUFvQixDQUFBO0FBTXhDOztHQUVHO0FBQ0gsU0FBd0IsUUFBUSxDQUFDLFFBQWdCLEVBQUUsS0FBYTtJQUM5RCxNQUFNLEtBQUssR0FBRyw4QkFBTSxDQUFDLEVBQUMsQ0FBQyxRQUFRLENBQUMsRUFBRSxLQUFLLEVBQUMsQ0FBQyxDQUFBO0lBQ3pDLE1BQU0sVUFBVSxHQUFXLEVBQUUsQ0FBQTtJQUM3QixNQUFNLGFBQWEsR0FBRyxNQUFNLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxDQUFBO0lBRXhDLG1DQUFtQztJQUNuQyxLQUFLLElBQUksQ0FBQyxHQUFHLENBQUMsRUFBRSxDQUFDLEdBQUcsYUFBYSxDQUFDLE1BQU0sRUFBRSxDQUFDLEVBQUUsRUFBRTtRQUM3QyxNQUFNLFlBQVksR0FBRyxhQUFhLENBQUMsQ0FBQyxDQUFDLENBQUE7UUFDckMsc0NBQXNDO1FBQ3RDLE1BQU0sWUFBWSxHQUFHLFlBQVksQ0FBQyxLQUFLLENBQUMsV0FBVyxDQUFDO1lBQ2xELENBQUMsQ0FBQyxJQUFJLFlBQVksRUFBRTtZQUNwQixDQUFDLENBQUMsWUFBWSxDQUFBO1FBQ2hCLE1BQU0sSUFBSSxHQUFHLG9CQUFVLENBQUMsWUFBWSxDQUFDLENBQUE7UUFDckMsTUFBTSxNQUFNLEdBQUcsS0FBSyxDQUFDLFlBQVksQ0FBQyxDQUFBO1FBRWxDLHlCQUF5QjtRQUN6QixJQUFJLEtBQUssQ0FBQyxPQUFPLENBQUMsTUFBTSxDQUFDLEVBQUU7WUFDekIsS0FBSyxJQUFJLENBQUMsR0FBRyxDQUFDLEVBQUUsQ0FBQyxHQUFHLE1BQU0sQ0FBQyxNQUFNLEVBQUUsQ0FBQyxFQUFFLEVBQUU7Z0JBQ3RDLFVBQVUsQ0FBQyxJQUFJLENBQUMsRUFBQyxRQUFRLEVBQUUsSUFBSSxFQUFFLEtBQUssRUFBRSxNQUFNLENBQUMsQ0FBQyxDQUFDLEVBQUMsQ0FBQyxDQUFBO2FBQ3BEO1NBQ0Y7YUFBTTtZQUNMLFVBQVUsQ0FBQyxJQUFJLENBQUMsRUFBQyxRQUFRLEVBQUUsSUFBSSxFQUFFLEtBQUssRUFBRSxNQUFNLEVBQUMsQ0FBQyxDQUFBO1NBQ2pEO0tBQ0Y7SUFFRCxPQUFPLFVBQVUsQ0FBQTtBQUNuQixDQUFDO0FBMUJELDJCQTBCQyJ9